import React from 'react';

const SignOutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12.5" height="13.028" viewBox="0 0 12.5 13.028">
    <g transform="translate(-539.926 -479)">
      <path d="M547.061,479.886v4.2a.886.886,0,1,1-1.772,0v-4.2a.886.886,0,1,1,1.772,0Zm-4.165.572a.886.886,0,1,1,.931,1.507,4.479,4.479,0,1,0,4.671-.016.885.885,0,1,1,.919-1.514,6.249,6.249,0,1,1-6.52.023Z"/>
    </g>
  </svg>
);
export default SignOutIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/SignOutIcon.js